import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { getContact, updateContact, ContactCreateInput } from '../api/contacts';

export function useContact(id: string) {
  return useQuery({
    queryKey: ['contact', id],
    queryFn: () => getContact(id),
    enabled: !!id,
    staleTime: 30_000,
  });
}

export function useUpdateContact(id: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: Partial<ContactCreateInput>) => updateContact(id, input),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['contact', id] });
      void queryClient.invalidateQueries({ queryKey: ['contacts'] });
    },
  });
}
